import { Partial } from '@40seas/entities/common';
import { CreateFundsDto } from './create.funds.dto';

export class UpdateFundsDto extends Partial(CreateFundsDto) {}
